import { render, staticRenderFns } from "./dev-draggable-menu.vue?vue&type=template&id=a0bf8118"
import script from "./dev-draggable-menu.vue?vue&type=script&lang=js"
export * from "./dev-draggable-menu.vue?vue&type=script&lang=js"
import style0 from "./dev-draggable-menu.vue?vue&type=style&index=0&id=a0bf8118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports